import { Breadcrumb,Select,Input,Form,Button,Modal,InputNumber,Space,Popconfirm,message,Spin} from "antd"
import Header from "../../components/dashboard/header"
import { Link, useNavigate } from "react-router-dom"
import { DashboardOutlined,PlusSquareOutlined,EditOutlined,DeleteOutlined } from "@ant-design/icons"
import {AiOutlineSetting} from "react-icons/ai";
import {BsArrowDownUp} from "react-icons/bs"
import DataTable from "../../components/common/table";
import {useState,useRef, useContext,useEffect} from "react";
import { useCreatePayrollApproval, useDeletePayrollApprovalStage, useFetchPayrollApprovalStages, useUpdatePayrollApprovalStage } from "../../hooks/payrollApprovalStages/payrollApprovalStagesQuery";
import { useRoles } from "../../hooks/roles/rolesQuery";
import RefreshContext from "../../context/refreshContext";
import { extractValueFromInputRef, scrollToTop } from "../../helpers/dom";
import { hasPayrollAccess } from "../../helpers/roles";
import { userStore } from "../../store/userStore";

const {Option} =  Select;



const approvalRolesColumns = [
    {
        title:'S/N',
        dataIndex:"id",
        key:"id"
    },
    {
        title:"Role",
        dataIndex:"role",
        key:"role"
    },
    {
        title:"Priority",
        dataIndex:"approvalOrder",
        key:"priority"
    },
    {
        title:"Actions",
        key:"actions",
        render:(_,role)=> <PayrollApprovalStageEdit role={role}/>
    }
];


function PayrollApprovalStageEdit({role}){
    const [isOpen,setIsOpen] = useState(false);
    const [r,setR] = useState("");

    const handleOpen = ()=> setIsOpen(true);
    const handleClose =()=> setIsOpen(false);

    const {flag,setFlag} = useContext(RefreshContext);

    const titleRef = useRef(null);
    const orderRef = useRef(null);

    const roles = useRoles();


    const updatePayrollApprovalStage = useUpdatePayrollApprovalStage();
    const deletePayrollApprovalStage = useDeletePayrollApprovalStage();

    const confirmDelete = async()=>{
        const {message:response} = await deletePayrollApprovalStage(role.id);
        message.success(response??"Payroll approval stage removed successfully");
        setFlag(!flag);
    }

    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            order:orderRef.current.value,
            role:r
        }
        const {message:response } = await updatePayrollApprovalStage(role.id,payload);
        message.success(response??"approval stage updates successfully");
        setIsOpen(false);
        setFlag(!flag);
    }

    return(
        <>
            <Space size="small" wrap>
                <Button type="primary" onClick={handleOpen}>
                    <EditOutlined />
                    Edit
                </Button>
                <Popconfirm
                    title="Delete this Role"
                    description="Are you sure to delete this role?"
                    onConfirm={confirmDelete}
                    onCancel={()=>null}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="primary" danger>
                        <DeleteOutlined />
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal title={'Edit approval role'} footer={null} open={isOpen} onCancel={handleClose}>
                <Form initialValues={{...role}}>
                    <Form.Item name="title">
                        <Input placeholder="Enter role title" ref={titleRef}/>
                    </Form.Item>
                    <Form.Item name="role">
                        <Select placeholder="select a role" onChange={(e)=>setR(e)}>
                            {
                                roles.map((r,idx)=>(
                                    <Option value={r.name} key={idx}>{(r.name).toLowerCase()}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item name="approvalOrder">
                        <InputNumber style={{width:'100%'}} placeholder="enter role priority"/>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span:8,
                            offset:20
                        }}
                        className="submit-button-wrapper"
                    >
                        <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}


export default function PayrollApprovalStage(){
    const navigate = useNavigate();
    const user = userStore(state => state.user);
    
    const [isOpen,setIsOpen] = useState(false);
    const [r,setR] = useState("");

    const handleOpen = ()=> setIsOpen(true);
    const handleClose = ()=> setIsOpen(false);

    const {flag,setFlag} = useContext(RefreshContext);

    // Check access permissions
    useEffect(() => {
        if (user && !hasPayrollAccess(user.roles)) {
            message.error('You do not have permission to access this page');
            navigate('/dashboard');
        }
    }, [user, navigate]);

    useEffect(()=>{
        scrollToTop();
    },[]);

    const titleRef = useRef(null);
    const orderRef = useRef(null);
    const roles = useRoles();

    const {loading,payrollApprovals:payrollApprovalsStages} = useFetchPayrollApprovalStages(flag);
    const createPayrollApproval = useCreatePayrollApproval();

    const handleSubmit = async ()=>{
        const payload = {
            title:extractValueFromInputRef(titleRef),
            approvalOrder:orderRef.current.value,
            role:r
        };

        const {message:response} = await createPayrollApproval(payload);
        message.success(response??"Payroll approval created successfully");
        setIsOpen(false);
        setFlag(!flag);
    }


    return(
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <AiOutlineSetting/>
                                <Link to={"/dashboard"}>Configuration</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <BsArrowDownUp />
                                <Link to="/dashboard/payroll-approval">Payroll Approval Stages</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{display:'flex',gap:'1em'}}>
                            <Button style={{backgroundColor:"green",color:"#FFFFFF"}} onClick={handleOpen}>
                                <PlusSquareOutlined />
                                Add Role
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={approvalRolesColumns} data={payrollApprovalsStages}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal title="Create Approval Role" footer={null} open={isOpen} onCancel={handleClose}>
                <Form>
                    <Form.Item>
                        <Input placeholder="Enter role title" ref={titleRef} />
                    </Form.Item>
                    <Form.Item>
                        <Select placeholder="select a role" onChange={(e)=>setR(e)}>
                            {
                                roles.map((r,idx)=>(
                                    <Option value={r.name} key={idx}>{(r.name).toLowerCase()}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item name="priority">
                        <InputNumber ref={orderRef} style={{width:'100%'}} placeholder="enter role priority"/>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span:8,
                            offset:20
                        }}
                        className="submit-button-wrapper"
                    >
                        <Button style={{backgroundColor:"green"}} size="large" type="primary" htmlType="submit" onClick={handleSubmit}>
                            Create
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
